export const LOCALE_EN_US = 'en_US'
export const LOCALE_EN_GB = 'en_GB'
export const LOCALE_EN_UK = 'en_GB'
export const LOCALE_DE_DE = 'de_DE'
export const LOCALE_ES_MX = 'es_MX'
export const LOCALE_IT_IT = 'it_IT'
export const LOCALE_EN_CA = 'en_CA'
export const LOCALE_FR_CA = 'fr_CA'

export const DATE_LOCALES: Record<string, string> = {
    [LOCALE_EN_US]: 'en-US',
    [LOCALE_EN_GB]: 'en-GB',
    [LOCALE_DE_DE]: 'de-DE',
    [LOCALE_ES_MX]: 'es-MX',
    [LOCALE_IT_IT]: 'it-IT',
    [LOCALE_EN_CA]: 'en-CA',
    [LOCALE_FR_CA]: 'fr-CA'
}
